import React, { useState, useEffect } from "react";
import "./SpotRegistration.css";
import { FaRupeeSign } from "react-icons/fa";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  FieldArray,
  useFormikContext,
} from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import BASE_URL from "../Config";

const SeparateActivity = () => {
  const [paymentdetails, setPayment] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [batchTimeData, setBatchTimeData] = useState(null);
  const [editActivityData, setEditActivityData] = useState(null);
  const [userActions, setUserActions] = useState([]);

  const [regIdData, setRegIdData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    deletegate_category: "",
    dName: "",
    ddesignation: "",
    demail: "",
    ddial_code: "91",
    dmobile: "",
    organization_name: "",
    GSTIN: "",
    type: "",
    amount: "",
    tax: "",
    total_amount: "",
    url_for_qr: "",
    event_id: "",
    restrictions: [],
  });
  const [selectedCategory, setSelectedCategory] = useState(
    initialValues?.deletegate_category || "Delegate"
  );
  const fetchSingleRegistration = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getSingleUserInfo`, {
        id,
      });

      const data = response.data?.data;
      const activity = response.data?.data?.activity;
      setEditActivityData(activity); // optional, if needed elsewhere
      setRegIdData(response.data?.data?.delegate_reg_id); // optional, if needed elsewhere

      if (data) {
        // Extract activity IDs from the activity array
        const selectedActivityIds = activity?.map((a) => a.Action_Type) || [];
        setInitialValues((prev) => ({
          ...prev,
          dName: data.name || "",
          dmobile: data.mobile || "",
          ddial_code: data.dial_code?.replace("+", "") || "91",
          demail: data.email || "",
          ddesignation: data.designation || "",
          organization_name:
            data?.organization_name ||
            data?.deletegate_registation?.organization_name ||
            "-" ||
            "",
          GSTIN: data.deletegate_registation?.GSTIN || "",
          deletegate_category: data.deletegate_category || "Delegate",
          refNumber: data.id || "",
          delegateFee: data.amount || "",
          payment_mode: data.payment_mode || "",
          type: data.type || "",
          url_for_qr: data.url_for_qr_code || "",
          amount: data.per_delegate || "",
          tax: data.per_delegate_tax || "",
          total_amount: data.total_delegate || "",
          restrictions: selectedActivityIds, // ✅ Here we set pre-checked activities
        }));
      }
    } catch (error) {
      console.error("Error fetching registration data:", error);
    }
  };

  const AutoTotalCalculator = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
      const amount = parseFloat(values.amount) || 0;
      const tax = parseFloat(values.tax) || 0;
      setFieldValue("total_amount", amount + tax);
    }, [values.amount, values.tax, setFieldValue]);

    return null; // it doesn't render anything
  };

  useEffect(() => {
    if (parseInt(id, 10) > 0) {
      fetchSingleRegistration();
    }
  }, [id]);

  const getValidationSchema = (category) => {
    const requiredCategories = ["Sponsor", "Exhibitor", "Advertiser"];
    const isStrictRequired = requiredCategories.includes(category);

    const baseFields = {
      dName: Yup.string().required("Name is required"),
    };

    if (isStrictRequired) {
      return Yup.object().shape({
        ...baseFields,
        dmobile: Yup.string()
          .matches(/^[0-9]{10,15}$/, "Invalid mobile number")
          .required("Mobile number is required"),
        demail: Yup.string()
          .email("Invalid email")
          .required("Email is required"),
        organization_name: Yup.string().required(
          "Organization name is required"
        ),
        GSTIN: Yup.string()
          .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/,
            "Invalid GSTIN format"
          )
          .notRequired("GSTIN is required"),
      });
    } else {
      return Yup.object().shape({
        ...baseFields,
        organization_name: Yup.string(), // optional
        GSTIN: Yup.string()
          .nullable()
          .when("organization_name", {
            is: (orgName) => orgName && orgName.trim() !== "",
            then: (schema) =>
              schema
                .notRequired("GSTIN is required")
                .matches(
                  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/,
                  "Invalid GSTIN format"
                ),
            otherwise: (schema) => schema.notRequired(),
          }),
      });
    }
  };

  const getPaymentEventData = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getMasterEvent`);

      setEventData(response.data?.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    getPaymentEventData();
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const userRole = parseInt(sessionStorage.getItem("userRole"), 10);

      const payload = {
        id: id || "",
        name: values.dName,
        event_id: eventData[0]?.id,
        mobile: values.dmobile,
        dial_code: values.ddial_code,
        email: values.demail,
        designation: values.ddesignation,
        organization_name: values.organization_name,
        GSTIN: values.GSTIN,
        type: values.type || "",
        payment_mode: values.payment_mode || "",
        deletegate_category: values.deletegate_category || "Delegate",
        amount: values.type === "Free" ? 0 : values.amount,
        tax: values.type === "Free" ? 0 : values.tax,
        total_amount: values.type === "Free" ? 0 : values.total_amount,
        url_for_qr: "",
        payment_status: "Pending",
        delegate_reg_id: regIdData,
        restrictions: values.restrictions.map((id) => ({ Action_Type: id })),
      };

      const response = await axios.post(
        parseInt(id, 10) > 0
          ? `${BASE_URL}/updateRegistrationfromAdmin`
          : `${BASE_URL}/createRegistrationfromAdmin`,
        payload
      );

      resetForm();

      if (userRole === 5) {
        navigate("/review-list-of-spot-registration");
      } else {
        navigate("/express-entry/admin-badge-list");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };
  const getPayment = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getSpotPaymentFee`);
      const data = response.data?.data;

      if (Array.isArray(data) && data.length > 0) {
        setPayment(data);
        const amount = Number(data[0]?.amount) || 0;
        const tax = Number(data[0]?.tax) || 0;

        setInitialValues((prev) => ({
          ...prev,
          amount,
          tax,
          total_amount: amount + tax,
        }));
      }
    } catch (error) {
      console.error("Error fetching payment details:", error);
    }
  };

  const getActivityTypeData = async (userId) => {
    try {
      const res = await axios.post(`${BASE_URL}/getActivityType`, { id: 1 });
      const activities = res.data?.data?.activity || [];
      const actions = res.data?.data?.userActions || [];

      setBatchTimeData(activities);
      setUserActions(actions);

      const allIds = activities.map((a) => a.Activity_Type_ID);
      if (!(parseInt(id) > 0)) {
        setInitialValues((prev) => ({
          ...prev,
          restrictions: allIds, // Only pre-check if it's a new registration
        }));
      }

      return activities;
    } catch (e) {
      console.error(e);
      return [];
    }
  };

  useEffect(() => {
    getActivityTypeData();
    getPayment();
  }, []);
  const handleBadgePrintCopy = async (item) => {
    try {
      // Navigate to Badge Print page
      navigate("/express-entry/admin-badge-list");
    } catch (error) {
      console.error("Error updating badge status:", error);
      // alert("Something went wrong while updating badge status.");
    }
  };
  const handleLogout = () => {
    // Clear user session or authentication data
    sessionStorage.clear(); // or localStorage.clear();

    // Redirect to the homepage
    navigate("/admin/login");
  };
  return (
    <div className="card">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <div>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              marginRight: "10px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => navigate("/express-entry/admin-badge-list")}
          >
            List of Admin User
          </button>
          <button
            style={{
              background: "#44929f",
              padding: "6px 20px",
              borderRadius: "40px",
              fontSize: "16px",
              fontWeight: 600,
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>

      <div className="card-body">
        <Formik
          initialValues={initialValues}
          enableReinitialize={true} // ✅ Important!
          validationSchema={getValidationSchema(selectedCategory)}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <Form>
              <fieldset id="step1">
                <div className="form-card clearfix">
                  {/* Fee Summary */}
                  <div className="package-item">
                    <h3 className="package-title">Delegate Fee</h3>
                    <div className="delegate-fees row">
                      <div className="col-md-12 col-sm-12">
                        <div className="delegate-item">
                          <p>
                            <span>Fee</span>
                            <strong className="d-flex align-items-center gap-2">
                              <FaRupeeSign /> {paymentdetails[0]?.amount}
                            </strong>
                          </p>
                          <p>
                            <span>Tax</span>
                            <strong className="d-flex align-items-center gap-2">
                              <FaRupeeSign /> {paymentdetails[0]?.tax}
                            </strong>
                          </p>
                          <p>
                            <span>Total</span>
                            <strong className="d-flex align-items-center gap-2">
                              <FaRupeeSign /> {paymentdetails[0]?.total_amount}
                            </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Delegate Type */}
                  <h2 className="package-title company">Deletegate Type</h2>
                  <div className="row mb-3">
                    <div className="form-group mb-3 col-md-6">
                      <Field
                        as="select"
                        name="deletegate_category"
                        className="form-control"
                        onChange={(e) => {
                          const selected = e.target.value;
                          setFieldValue("deletegate_category", selected);
                          setSelectedCategory(selected); // update schema
                        }}
                      >
                        <option value="Delegate">Delegate</option>
                        <option value="Speaker">Speaker</option>
                        <option value="Sponsors">Sponsors</option>
                        <option value="Exhibitor">Exhibitor</option>
                        <option value="Special_Guest">Special Guest</option>
                        <option value="Media_Press">Media_Press</option>
                        <option value="Organaizer">Organizer</option>
                        <option value="advertiser">Advertiser</option>
                      </Field>
                    </div>
                  </div>

                  {/* Delegate Info */}
                  <h2 className="package-title">Delegates Information</h2>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Name</label>
                      <Field
                        name="dName"
                        className="form-control"
                        placeholder="Enter a Name"
                      />
                      <ErrorMessage
                        name="dName"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Designation</label>
                      <Field
                        name="ddesignation"
                        className="form-control"
                        placeholder="Enter Designation"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Email</label>
                      <Field
                        name="demail"
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                      />
                      <ErrorMessage
                        name="demail"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Mobile No.</label>
                      <div className="input-group">
                        <Field as="select" name="ddial_code" className="px-3">
                          <option value="91">91</option>
                        </Field>
                        <Field
                          name="dmobile"
                          className="form-control"
                          placeholder="Enter Mobile No."
                        />
                      </div>
                      <ErrorMessage
                        name="dmobile"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  </div>

                  {/* Company Info */}
                  <h2 className="package-title company">Company Information</h2>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Organization Name</label>
                      <Field
                        name="organization_name"
                        className="form-control"
                        placeholder="Organization Name"
                      />
                      <ErrorMessage
                        name="organization_name"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>GSTIN</label>
                      <Field name="GSTIN">
                        {({ field, form }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            placeholder="GSTIN"
                            style={{ textTransform: "uppercase" }}
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              form.setFieldValue("GSTIN", value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="GSTIN"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  </div>
                  <h2 className="package-title company font-bold mt-4">
                    Payment Information
                  </h2>

                  <div
                    className="row mb-3 p-3"
                    style={{ backgroundColor: "#f3fcff", borderRadius: "8px" }}
                  >
                    <div className="row mb-3 p-3">
                      {/* Payment Type */}
                      <div className="form-group mb-0 col-md-12 d-flex align-items-center">
                        <label
                          className="me-3 mb-0"
                          style={{ fontWeight: "500", color: "#1B1B1D" }}
                        >
                          Payment Type
                        </label>

                        <div className="form-check me-3">
                          <Field name="type">
                            {({ field, form }) => (
                              <div className="form-check me-3">
                                <input
                                  type="radio"
                                  {...field}
                                  value="paid"
                                  id="paid"
                                  className="form-check-input custom-radio"
                                  checked={
                                    field.value?.toLowerCase() === "paid"
                                  } // case-insensitive
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="paid"
                                >
                                  Paid
                                </label>
                              </div>
                            )}
                          </Field>
                        </div>

                        <div className="form-check">
                          <Field
                            type="radio"
                            name="type"
                            value="Free"
                            className="form-check-input custom-radio"
                            id="Free"
                          />
                          <label className="form-check-label" htmlFor="Free">
                            Free
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Conditionally show Payment Mode if "Paid" is selected */}
                    {values.type === "Paid" ||
                      (values.type === "paid" && (
                        <>
                          <div className="form-group mb-3 col-md-12 d-flex align-items-center">
                            <label
                              className="me-3 mb-0"
                              style={{ fontWeight: "500", color: "#1B1B1D" }}
                            >
                              Payment Mode
                            </label>

                            <div className="form-check me-5">
                              <Field
                                type="radio"
                                name="payment_mode"
                                value="Upi"
                                className="form-check-input custom-radio"
                                id="Upi"
                              />
                              <label className="form-check-label" htmlFor="Upi">
                                UPI
                              </label>
                            </div>

                            <div className="form-check me-4">
                              <Field
                                type="radio"
                                name="payment_mode"
                                value="Card"
                                className="form-check-input custom-radio"
                                id="Card"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="Card"
                              >
                                Card
                              </label>
                            </div>

                            <div className="form-check me-4">
                              <Field
                                type="radio"
                                name="payment_mode"
                                value="Cash"
                                className="form-check-input custom-radio"
                                id="Cash"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="Cash"
                              >
                                Cash
                              </label>
                            </div>

                            <div className="form-check me-4">
                              <Field
                                type="radio"
                                name="payment_mode"
                                value="NEFTChequeDD"
                                className="form-check-input custom-radio"
                                id="NEFTChequeDD"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="NEFTChequeDD"
                              >
                                NEFT/Cheque/DD
                              </label>
                            </div>
                          </div>

                          <AutoTotalCalculator />

                          <div className="row mt-3">
                            <div className="form-group mb-3 col-md-4">
                              <label>Amount</label>
                              <Field
                                name="amount"
                                type="number"
                                className="form-control"
                                placeholder="Enter Amount"
                              />
                            </div>

                            <div className="form-group mb-3 col-md-4">
                              <label>Tax</label>
                              <Field
                                name="tax"
                                type="number"
                                className="form-control"
                                placeholder="Enter Tax"
                              />
                            </div>

                            <div className="form-group mb-3 col-md-4">
                              <label>Total Amount</label>
                              <Field
                                name="total_amount"
                                type="number"
                                className="form-control"
                                placeholder="Total Amount"
                                disabled
                              />
                            </div>
                          </div>
                        </>
                      ))}
                  </div>

                  <div className="w-full">
                    <h2 className="package-title company">Activity Type</h2>
                    <FieldArray name="restrictions">
                      {({ push, remove, form }) => (
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                          {batchTimeData?.map((activity) => {
                            const isChecked = (
                              form.values.restrictions || []
                            ).includes(activity.Activity_Type_ID);

                            return (
                              <label
                                key={activity.Activity_Type_ID}
                                htmlFor={`activity-${activity.Activity_Type_ID}`}
                                className="flex items-center p-3 border rounded-lg shadow-sm hover:shadow-md transition-shadow  cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  id={`activity-${activity.Activity_Type_ID}`}
                                  name="restrictions"
                                  value={activity.Activity_Type_ID}
                                  checked={isChecked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      push(activity.Activity_Type_ID);
                                    } else {
                                      const idx =
                                        form.values.restrictions.indexOf(
                                          activity.Activity_Type_ID
                                        );
                                      if (idx > -1) remove(idx);
                                    }
                                  }}
                                  className="mr-3 w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                />
                                <span className="text-gray-800 font-medium ml-1">
                                  {activity.Activity_Name}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      )}
                    </FieldArray>

                    <ErrorMessage
                      name="restrictions"
                      component="div"
                      className="text-red-500 text-sm mt-2"
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-md btn-primary tra-black-hover submit"
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      background: "#F8C400",
                      border: "0",
                      color: "#1B1B1D",
                      borderRadius: "50px",
                      padding: "8px 20px",
                      marginTop: "20px",
                      float: "right",
                      height: "37px",
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </fieldset>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SeparateActivity;
